import CreateDashboardComponent from "./CreateDashboardComponent";

interface EmptyDashboardComponentsProps {
  isCreator: boolean;
  dashboardId: string;
}

const EmptyDashboardComponents = ({
  isCreator,
  dashboardId,
}: EmptyDashboardComponentsProps) => {
  return (
    <div className="flex-1 flex flex-row sm-h:flex-col gap-6 items-center justify-center h-full">
      <img src="/empty-dashboard-components.svg" className="h-full max-h-52 sm-h:max-h-48 md-h:max-h-64 lg-h:max-h-80 xl-h:max-h-96 object-contain" />

      <div className="flex flex-col gap-6 items-center justify-center">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col gap-2">
            {isCreator && (
              <>
                <p className="text-center text-xl font-bold">
                  Você ainda não tem gráficos
                </p>

                <p className="text-center text-sm text-white-400">
                  Adicione seu primeiro gráfico para começar a ver seus dados
                </p>
              </>
            )}

            {!isCreator && (
              <>
                <p className="text-center text-xl font-bold">
                  Este dashboard ainda não tem gráficos
                </p>
              </>
            )}
          </div>

          {isCreator && (
            <CreateDashboardComponent
              dashboardId={dashboardId}
              initialPosition={{
                x: 0,
                y: 0,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default EmptyDashboardComponents;
